<template>
    <div>
        <el-row :gutter="20">
            <el-col class="quick">
                <el-card shadow="hover" style="height: 315px">
                    <div slot="header" class="clearfix">
                        <span style="font-size: 18px">快捷入口</span>
                    </div>
                    <div class="quick-access">
                        <div class="access-item" @click="toPath('/substituteDrivingOrder')">
                            <div>
                                <img src="../../assets/img/order.png" alt="" />
                            </div>
                            <p>订单监控</p>
                        </div>
                        <div class="access-item" @click="toPath('/driver')">
                            <div>
                                <img src="../../assets/img/driver.png" alt="" style="width: 50px; height: 50px" />
                            </div>
                            <p>司机管理</p>
                        </div>
                        <div class="access-item" @click="toPath('/user')">
                            <div>
                                <img src="../../assets/img/user.png" alt="" />
                            </div>
                            <p>乘客信息</p>
                        </div>
                        <div class="access-item" @click="toPath('/labelLists')">
                            <div>
                                <img src="../../assets/img/label.png" alt="" />
                            </div>
                            <p>标签管理</p>
                        </div>
                        <div class="access-item" @click="toPath('/advertInformation')">
                            <div>
                                <img src="../../assets/img/advertInformation.png" alt="" />
                            </div>
                            <p>广告库</p>
                        </div>
                        <div class="access-item" @click="toPath('/article')">
                            <div>
                                <img src="../../assets/img/article.png" alt="" />
                            </div>
                            <p>公告</p>
                        </div>
                    </div>
                </el-card>
            </el-col>

            <el-col style="width: 280px">
                <el-card shadow="hover" style="height: 315px">
                    <div class="user-info">
                        <div class="user-info-cont">
                            <div class="user-info-name">{{ userData.name }}</div>
                        </div>
                    </div>
                    <div class="user-info-list">
                        <span>绑定号码:</span>

                        <span>{{ userData.phone }}</span>
                    </div>
                    <div class="user-info-list">
                        <span>所属城市:</span>

                        <span class="city-main">{{ userData.city.name }}</span>
                    </div>
                    <div class="user-info-list">
                        <span>状态:</span>

                        <span>
                            <el-tag :type="userData.status.val == '0' ? 'warning' : userData.status.val == '2' ? 'danger' : ''">
                                {{ userData.status.alias }}</el-tag
                            >
                        </span>
                    </div>
                    <div class="user-info-list">
                        <span>验证状态:</span>

                        <span>
                            <el-tag :type="userData.verify.val == '1' ? 'warning' : ''">{{ userData.verify.alias }}</el-tag>
                        </span>
                    </div>
                    <div class="user-info-list">
                        <span>锁定状态:</span>

                        <span>{{ userData.locking.alias }}</span>
                    </div>

                    <div class="user-info-list">
                        <span> 注册时间:</span>

                        <span>{{ userData.reg_time.Ymd }}</span>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <el-row :gutter="20">
            <el-col :span="24">
                <el-card shadow="hover">
                    <div>
                        <div style="text-align: center; margin: 10px 0">
                            <span>城市:</span>
                            <span>{{ userData.city.name }}</span>
                        </div>

                        <div class="statistics-box-head" style="margin: 10px 0">
                            <span>日期:</span>

                            <!-- <el-date-picker v-model="search_data.day_time" type="date" placeholder="选择日期"
                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 150px;" clearable>
                            </el-date-picker> -->
                            <el-date-picker
                                v-model="search_time"
                                type="daterange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="timeChange"
                                style="width: 280px"
                            >
                            </el-date-picker>
                        </div>
                        <div class="statistics-box-head" style="margin: 10px 0">
                            <span style="display: inline-block; width: 90px; text-align: right; margin-right: 5px">模式:</span>
                            <el-select
                                v-model="search_data.type"
                                placeholder="请选择模式"
                                style="width: 200px; margin-right: 20px"
                                clearable
                            >
                                <el-option label="下单时间" value="0"></el-option>
                                <el-option label="完成时间" value="1"></el-option>
                            </el-select>
                        </div>

                        <div style="display: flex; justify-content: center; height: 32px; margin: 10px 0">
                            <el-button style="padding: 8px 10px" @click="searchStatistics">确定</el-button>

                            <el-button style="padding: 8px 10px" type="warning" @click="toOrderStatistics">详情 </el-button>
                        </div>
                    </div>

                    <!-- <div class="statistics-box-main">
                        <div style="margin: 0 20px">
                            <span>总单量</span>
                            <p>{{ order_data.count }}</p>
                        </div>

                        <div style="margin: 0 20px">
                            <span>总金额</span>
                            <p>{{ order_data.finish_amount }}</p>
                        </div>
                    </div> -->
                      <div :class="{'xiaolin-box-main':titleStr=='HAIKOU'}" class="statistics-box-main">
                        <div style="margin: 0 20px">
                            <span>总单量</span>
                            <p>{{ order_data.count }}</p>
                        </div>

                        <div style="margin: 0 20px">
                            <span>总金额</span>
                            <p>{{ order_data.finish_amount }}</p>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <el-row :gutter="20">
            <div>
                <div v-if="cityInfo.source != 'gengshifu'">
                    <el-col :span="12" style="margin-top: 10px">
                        <el-card shadow="hover">
                            <div style="text-align: center">
                                <img
                                    :src="require(`@/assets/img/${cityInfo.source}-android.png`)"
                                    alt=""
                                    style="width: 200px; height: 200px"
                                />
                                <p>安卓司机端下载</p>
                            </div>
                        </el-card>
                    </el-col>
                </div>

                <div v-else>
                    <el-col :span="12" style="margin-top: 10px">
                        <el-card shadow="hover">
                            <div style="text-align: center">
                                <img src="../../assets/img/gengshifu-android.png" alt="" style="width: 200px; height: 200px" />
                                <p>安卓司机端下载</p>
                            </div>
                        </el-card>
                    </el-col>
                </div>
            </div>
            <div>
                <div v-if="cityInfo.source == 'gengshifu'">
                    <el-col :span="12" style="margin-top: 10px">
                        <el-card shadow="hover">
                            <div style="text-align: center">
                                <img src="../../assets/img/gengshifu-ios.png" alt="" style="width: 200px; height: 200px" />
                                <p>苹果司机端下载</p>
                            </div>
                        </el-card>
                    </el-col>
                </div>

                <div v-else>
                   
                </div>
            </div>

            <!-- <div v-if="userData.city.city_code == 'CITY648A62135012159'">
 
                <el-col :span="12" style="margin-top: 10px">
                    <el-card shadow="hover">
                        <div style="text-align: center">
                            <img src="../../assets/img/pingan-driver.png" alt="" style="width: 200px; height: 200px" />
                            <p>苹果司机端下载</p>
                        </div>
                    </el-card>
                </el-col>
            </div>
            <div v-else>
                <el-col :span="12">
                    <el-card shadow="hover">
                        <div style="text-align: center">
                            <img src="../../assets/img/ios-driver.png" alt="" style="width: 200px; height: 200px" />
                            <p>苹果司机端下载</p>
                        </div>
                    </el-card>
                </el-col>
            </div> -->

            <div>
                <div v-if="cityInfo.source != 'gengshifu'">
                    <el-col :span="12" style="margin-top: 10px">
                        <el-card shadow="hover">
                            <div style="text-align: center">
                                <img
                                    :src="require(`@/assets/img/${cityInfo.source}-xiaochengxu.jpg`)"
                                    alt=""
                                    style="width: 200px; height: 200px"
                                />
                                <p>小程序二维码</p>
                            </div>
                        </el-card>
                    </el-col>
                </div>
                <div v-else>
                    <el-col :span="12" style="margin-top: 10px">
                        <el-card shadow="hover">
                            <div style="text-align: center">
                                <img src="../../assets/img/gengshifu-xiaochengxu.png" alt="" style="width: 200px; height: 200px" />
                                <p>小程序二维码</p>
                            </div>
                        </el-card>
                    </el-col>
                </div>
            </div>
        </el-row>

        <!-- 更新内容组件 -->
        <updateCont :isShow="updateCont_show"></updateCont>
    </div>
</template>

<script>
import bus from '../common/bus';
import updateCont from '../common/updateCont';
var _this;
export default {
    name: 'dashboard',
    components: {
        updateCont
    },
    data() {
        return {
            titleStr: '',

            userData: JSON.parse(localStorage.getItem('login')),
            cityInfo: JSON.parse(localStorage.getItem('cityInfo')),

            updateCont_show: false,

            search_time: '',

            order_data: {
                count: 0,
                finish_amount: 0
            },

            // 下拉搜索城市
            value_city_code: '',
            options_city_code: [],
            city_options_data: {
                page: 1,
                limit: 50,
                name: ''
            },

            search_data: {
                fixed_array: '',
                type: ''
            }
        };
    },

    created() {
        _this = this;
        console.log(_this.userData, 'userData');
        _this.titleStr = JSON.parse(localStorage.getItem('cityInfo')).city_tag;

        //     this.handleListener();
        //     this.changeDate();
        // },
        // activated() {
        //     this.handleListener();
        // },
        // deactivated() {
        //     window.removeEventListener('resize', this.renderChart);
        //     bus.$off('collapse', this.handleBus);
    },
    methods: {
        toOrderStatistics() {
            this.$router.push({
                path: '/orderStatistics'
            });
        },

        timeChange(val) {
            if (val != null) {
                _this.search_data.fixed_array = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data.fixed_array = '';
            }
        },

        searchStatistics() {
            _this
                .$post('/statistics/getOrderHomeCount', _this.search_data)
                .then((res) => {
                    _this.order_data = res.data;
                })
                .catch((err) => {});
        },

        toPath(path) {
            var navLists = JSON.parse(sessionStorage.getItem('navBar'));

            for (var i = 0; i < navLists.length; i++) {
                if (navLists[i].checked && navLists[i].index == path) {
                    // 如果导航存在checked，并且index等于path，则跳转路由
                    this.$router.push(path);
                    return;
                } else if (navLists[i].subs) {
                    // 如果存在subs
                    for (var j = 0; j < navLists[i].subs.length; j++) {
                        if (navLists[i].subs[j].checked && '/' + navLists[i].subs[j].index == path) {
                            // 如果导航存在checked，并且index等于path，则跳转路由
                            this.$router.push(path);
                            return;
                        }
                    }
                }
            }
        },
        toUpdateCont() {
            this.updateCont_show = !this.updateCont_show;
        }

        // handleListener() {
        //     bus.$on('collapse', this.handleBus);
        //     // 调用renderChart方法对图表进行重新渲染
        //     window.addEventListener('resize', this.renderChart);
        // },
        // handleBus(msg) {
        //     setTimeout(() => {
        //         this.renderChart();
        //     }, 200);
        // },
        // renderChart() {
        //     this.$refs.bar.renderChart();
        //      .$refs.line.renderChart();
        // }
    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;
}

.grid-content {
    display: flex;
    align-items: center;
    height: 100px;
}

.grid-cont-right {
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #999;
}

.grid-num {
    font-size: 30px;
    font-weight: bold;
}

.grid-con-icon {
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: #fff;
}

.grid-con-1 .grid-con-icon {
    background: rgb(45, 140, 240);
}

.grid-con-1 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-2 .grid-con-icon {
    background: rgb(100, 213, 114);
}

.grid-con-2 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-3 .grid-con-icon {
    background: rgb(242, 94, 67);
}

.grid-con-3 .grid-num {
    color: rgb(242, 94, 67);
}

.user-info {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #ccc;
    margin-bottom: 20px;
}

.user-avator {
    position: relative;
    width: 120px;
    height: 120px;
    background-color: #409eff;
    border-radius: 50%;
}

.user-avator img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: block;
    width: 100px;
    height: 100px;
}

.user-info-cont {
    flex: 1;
    font-size: 14px;
    color: #999;
}

.user-info-cont div:first-child {
    font-size: 30px;
    color: #222;
}

.user-info-list {
    font-size: 14px;
    color: #999;
    line-height: 25px;
    margin: 5px 0;
    padding-left: 10px;
    display: flex;
    align-items: center;
}

.user-info-list > span:first-of-type {
    display: inline-block;
    width: 100px;
}

.todo-item {
    font-size: 14px;
}

.todo-item-del {
    text-decoration: line-through;
    color: #999;
}

.schart {
    width: 100%;
    height: 300px;
}

.quick-access {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.quick-access .access-item {
    width: 15%;
    cursor: pointer;
    padding: 20px 10px;
    box-sizing: border-box;
}

.quick-access .access-item:hover {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.quick-access .access-item div {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    /* background-color: #fe6114; */
    border-radius: 50%;
    margin: 0 auto;
}



.quick-access .access-item div img {
    display: block;
    width: 50px;
    height: 50px;
    margin: 0 auto;
}

.quick-access .access-item p {
    text-align: center;
    font-size: 14px;
    margin-top: 20px;
}

.to-updateCont {
    cursor: pointer;
}

.user-info-name {
    font-size: 18px !important;
}

.statistics-box-head {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.statistics-box-head > div > span {
    margin-right: 5px;
    font-size: 14px;
    font-weight: 500;
}

.statistics-box-main {
    display: flex;
    justify-content: center;
}

.statistics-box-main > div {
    max-width: 30%;
    text-align: center;
    width: 150px;
}

.statistics-box-main > div > span {
    font-size: 14px;
    font-weight: 500;
    margin: 0 auto;
    background-color: #fe6114;
    display: block;
    height: 30px;
    line-height: 30px;
    color: #fff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}


/* 小琳代驾样式 */
.xiaolin-box-main > div > span {
    font-size: 14px;
    font-weight: 500;
    margin: 0 auto;
    background-color: #1BA1FF;
    display: block;
    height: 30px;
    line-height: 30px;
    color: #fff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.statistics-box-main > div > p {
    font-size: 16px;
    font-weight: 800;
    height: 30px;
    line-height: 30px;
    background-color: #eee;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.quick {
    width: calc(100% - 280px);
}

.topUDataProgress {
    font-size: 14px;
    color: #409eff;
    transition: 0.3s;
}

.topUDataProgress:hover {
    color: #e6a51a;
}
.city-main {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: calc(100% - 100px);
}
</style>
